<template>
  <div class="flex flex-col h-full w-full" :style="{ paddingBottom: `${paddingBottom + 16}px` }">
    <tabs-wrapper class="h-full w-full">
      <tab title="כל החיבורים" description="חיבורים לסליקה, חשבוניות, ווטסאפ, ה-AI שלנו ועוד." class="overflow-y-auto">
        <div class="flex flex-col gap-6 p-4 pt-0 md:max-w-[650px]">
          <IntegrationSection title="בינה מלאכותית">
            <div class="flex flex-col gap-3">
              <AdminAiCard />
              <WhatsAppBotCard />
            </div>
          </IntegrationSection>

          <IntegrationSection title="תשלומים וחשבוניות">
            <PaymentIntegrations />
          </IntegrationSection>

          <IntegrationSection title="ערוצי תקשורת">
            <WhatsAppIntegrationCard />
          </IntegrationSection>

          <IntegrationSection title="שיווק">
            <PixelIntegrationCard />
          </IntegrationSection>
        </div>
      </tab>

      <tab title="בוט WhatsApp" description="הגדרת המשימות שהבוט מבצע בשיחות עם לקוחות" class="overflow-y-auto">
        <div class="md:max-w-[700px] md:mx-auto">
          <WhatsappBotTab />
        </div>
      </tab>
    </tabs-wrapper>

    <ConfirmDialog />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAdminStore } from '@app/stores';
import { useAdminOnlyPage } from '@app/composables/admin-only-guard';
import { useDrawer, useSharedStore } from '@torim-app/shared-components';
import { AdminRouteNames } from '@app/router/route-names';
import IntegrationSection from '@app/components/admin/components/integrations/IntegrationSection.vue';
import WhatsAppIntegrationCard from '@app/components/admin/components/integrations/WhatsAppIntegrationCard.vue';
import WhatsAppBotCard from '@app/components/admin/components/integrations/WhatsAppBotCard.vue';
import PixelIntegrationCard from '@app/components/admin/components/integrations/PixelIntegrationCard.vue';
import AdminAiCard from '@app/components/admin/components/integrations/AdminAiCard.vue';
import PaymentIntegrations from '@app/components/admin/components/PaymentIntegrations.vue';
import WhatsappBotTab from '@app/components/admin/pages/integrations/WhatsappBotTab.vue';
import ConfirmDialog from 'primevue/confirmdialog';
import WhatsAppConnect from '@app/components/admin/pages/configurations/WhatsAppConnect.vue';
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();
useAdminOnlyPage();
const sharedStore = useSharedStore();
const { setPage } = adminStore;

const paddingBottom = computed(() => sharedStore.bottomPadding);

const route = useRoute();
const router = useRouter();
const { openDrawer } = useDrawer();

// WhatsApp Business connect callback (native): the router sends Meta's OAuth redirect here
// with ?code&state=wa_connect. Strip it from the URL first — navigation closes drawers, and
// the code is single-use, so it must not be picked up twice — then reopen the connect
// drawer to finish the exchange.
let handledWaCode: string | undefined;
watch(() => route.query, async (query) => {
  const { code, state } = query as Record<string, string | undefined>;
  if (!code || state !== 'wa_connect' || code === handledWaCode) return;
  handledWaCode = code;
  await router.replace({ name: AdminRouteNames.Integrations });
  // The connect drawer the user left open was closed by this navigation; its close
  // animation clears the drawer slot after 300ms, so open the new one after that.
  setTimeout(() => openDrawer(WhatsAppConnect, { oauthCode: code }, { title: 'WhatsApp Business' }), 350);
}, { immediate: true });

onMounted(() => {
  trackEvent('integrations_viewed');
  setPage(AdminRouteNames.Integrations);
  adminStore.fetchBusinessData();
});
</script>
